import corporateRequest from 'utils/corporateRequest';

// ─── MANDATE ENDPOINTS (from Corporate Swagger) ──────────────────────────────

/**
 * GET /corporate/mandates
 * Get list of hiring mandates with filters, search, sorting, and pagination
 * Query params: search, roleType, hiringMode, employmentType, interviewType, plantLocation, corporateId, sort, order, pageLimit, pageNo
 */
export const getMandates = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await corporateRequest.get(`/corporate/mandates${queryString ? `?${queryString}` : ''}`);
  return response.data;
};

/**
 * GET /corporate/mandates/metrics
 * Get aggregate mandate metrics (headcount, male/female counts, percentages, total mandates)
 */
export const getMandateMetrics = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await corporateRequest.get(`/corporate/mandates/metrics${queryString ? `?${queryString}` : ''}`);
  return response.data;
};

/**
 * GET /corporate/mandates/:mandateId
 * Get a hiring mandate by ID
 */
export const getMandate = async (mandateId) => {
  const response = await corporateRequest.get(`/corporate/mandates/${mandateId}`);
  return response.data;
};

/**
 * POST /corporate/mandates
 * Create a hiring mandate
 * Body: { roleType, hiringMode, employmentType, interviewType, plantLocation, preferredStates, headcount, maleCount, femaleCount, joinedCount, expectedJoiningDate, additionalRemarks, submittedBy, corporateId }
 */
export const createMandate = async (data) => {
  const response = await corporateRequest.post('/corporate/mandates', data);
  return response.data;
};

/**
 * PUT /corporate/mandates/:mandateId
 * Update a hiring mandate
 * Body: { roleType, hiringMode, employmentType, interviewType, plantLocation, preferredStates, headcount, maleCount, femaleCount, joinedCount, expectedJoiningDate, additionalRemarks, submittedBy }
 */
export const updateMandate = async (mandateId, data) => {
  const response = await corporateRequest.put(`/corporate/mandates/${mandateId}`, data);
  return response.data;
};

/**
 * DELETE /corporate/mandates/:mandateId
 * Delete a hiring mandate by ID
 */
export const deleteMandate = async (mandateId) => {
  const response = await corporateRequest.delete(`/corporate/mandates/${mandateId}`);
  return response.data;
};

/**
 * GET /corporate/mandates/corporate/:corporateId
 * Get hiring mandates by corporate ID
 */
export const getMandatesByCorporate = async (corporateId) => {
  const response = await corporateRequest.get(`/corporate/mandates/corporate/${corporateId}`);
  return response.data;
};

/**
 * GET /corporates/:corporateId/branch
 * Get branches/plants for a corporate
 */
export const getCorporateBranches = async (corporateId, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await corporateRequest.get(`/corporates/${corporateId}/branch${queryString ? `?${queryString}` : ''}`);
  return response.data;
};

// Legacy support - map old function names to new endpoints
export const cancelMandate = (id, reason) => deleteMandate(id);
export const updateMandateCounts = (id, headcount, joined_count, declined_count, male_count, female_count) =>
  updateMandate(id, { headcount, maleCount: male_count, femaleCount: female_count, joinedCount: joined_count });
